import moment from "moment";

export const BELL_SECTIONS = ["Today", "This week", "Earlier"];

export const GITCHA_LEAD_TYPE = 41;

const actorOf = (item) =>
  String(
    item?.ContactUserId ||
      item?.ContactEmail ||
      item?.ContactName ||
      item?.SenderId ||
      item?.FromUserId ||
      [item?.FirstName, item?.LastName].filter(Boolean).join(" ") ||
      "",
  )
    .trim()
    .toLowerCase();

const subjectOf = (item) => String(item?.Want_ad_Id || item?.IntroductionId || item?.InventoryId || item?.Draft_Want_ad_Id || "");

export const bellCollapseKey = (item) => {
  const type = Number(item?.SubjectType);
  if (type === GITCHA_LEAD_TYPE) {
    const actor = actorOf(item);
    if (!actor) return null;
    return `${type}|${item?.ContactType || ""}|${actor}|${subjectOf(item)}|${item?.Source || ""}`;
  }
  return null;
};

export const isUnread = (item) => Number(item?.Read_Status) === 1;

const stampOf = (item, field) => {
  const value = item?.[field] || item?.LastUpdatedTS || item?.CreatedOn || item?.CreatedDate || null;
  const parsed = value ? moment.utc(value) : null;
  return parsed && parsed.isValid() ? parsed : null;
};

export const sectionOf = (stamp, now = moment()) => {
  if (!stamp) return "Earlier";
  const local = moment(stamp).local();
  const today = moment(now).local();
  if (local.isSame(today, "day")) return "Today";
  if (today.diff(local, "days", true) < 7) return "This week";
  return "Earlier";
};

export const collapseBell = (list = [], { idField = "NotificationId" } = {}) => {
  const out = [];
  const byKey = new Map();
  (Array.isArray(list) ? list : []).forEach((item) => {
    const key = bellCollapseKey(item);
    const found = key ? byKey.get(key) : null;
    if (found) {
      found.count += 1;
      found.ids.push(item?.[idField]);
      found.items.push(item);
      found.unread = found.unread || isUnread(item);
      return;
    }
    const entry = { key: key || `${item?.SubjectType}|${item?.[idField]}`, item, items: [item], ids: [item?.[idField]], count: 1, unread: isUnread(item) };
    if (key) byKey.set(key, entry);
    out.push(entry);
  });
  return out;
};

export const groupBySection = (entries = [], { now = moment(), stampField = "LastUpdatedTS", stamp = null } = {}) => {
  const sections = BELL_SECTIONS.map((label) => ({ label, entries: [] }));
  entries.forEach((entry) => {
    const when = stamp ? stamp(entry) : stampOf(entry.item || entry, stampField);
    const label = sectionOf(when, now);
    sections.find((section) => section.label === label).entries.push(entry);
  });
  return sections.filter((section) => section.entries.length > 0);
};

export const groupBell = (list, options = {}) => groupBySection(collapseBell(list, options), options);
